import "magnific-popup";
export default () => {
  $('.gallery-container').magnificPopup({
    gallery: {
      enabled: true
    },
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image'
    // other options
  });
}
